import React, { FC, RefObject } from 'react'

import AccountField from '../components/AccountField'
import { accountsNames } from '../constants'

const CreditAccountField: FC<{
  FormName: string
  creditAccountSearchButtonRef?: RefObject<any>
  searchAccountsFetcherName: string
  disabled: boolean
  checkClient?: any
  isRequired?: boolean
}> = ({ FormName, creditAccountSearchButtonRef, searchAccountsFetcherName, checkClient, disabled, isRequired }) => (
  <AccountField
    disabled={disabled}
    name="CreditAccNo"
    FormName={FormName}
    //@ts-ignore
    checkClient={checkClient}
    fetcherName={searchAccountsFetcherName}
    accountCredentials={accountsNames.credit}
    searchButtonRef={creditAccountSearchButtonRef}
    isRequired={isRequired}
  />
)

export default CreditAccountField
